export var pageSizeValues = [
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 75, label: "75" },
    { value: 100, label: "100" },
];
//# sourceMappingURL=page-size.js.map